import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Незатейливый крой, представляющий собой прямоугольный рюкзак с лямками из веревки на кулиске. В нижних углах рюкзака металлические кольца для аккуратного крепления лямок. Рюкзак изготовлен из плотной непромокаемой ткани Оксфорд. Размер рюкзака 35 см на 45 см.</p><p><b>Размеры:</b><br>Рюкзак представляет собой прямоугольник<br>в ширину: 35 см<br>в длину: 45 см<br>И лямки из веревочек длиной 530 мм каждая.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
